import { render, staticRenderFns } from "./NotificationsApp.vue?vue&type=template&id=31456ede&"
import script from "./NotificationsApp.vue?vue&type=script&lang=js&"
export * from "./NotificationsApp.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsApp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports